import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'
import { Size, Border, Color } from '../../const'
import { MEDIA_QUERY } from 'config/constants'

export const Button = ({
  type,
  width,
  height,
  onClick,
  disabled,
  children,
  primary,
  secondury,
  fontSize,
  style = {},
}) => (
  <Wrapper
    width={width}
    height={height}
    disabled={disabled}
    primary={primary}
    secondury={secondury}
    whileHover={{ scale: 1.0 }}
    whileTap={{ scale: 1.0 }}
    type={type}
    onClick={onClick}
    fontSize={fontSize}
    style={style}
  >
    {children}
  </Wrapper>
)

const getBorder = (props) => {
  let border = Border.BUTTON_BORDER_DEFAULT

  if (props.primary) {
    border = Border.BUTTON_BORDER
  }

  if (props.disabled) {
    border = Border.BUTTON_BORDER_DISABLED
  }

  return border
}

const getBackgroundColor = (props) => {
  let color = Color.BUTTON.DEFAULT

  if (props.primary) {
    color = Color.BUTTON.PRIMARY
  }

  if (props.disabled) {
    color = Color.BUTTON.DISABLED
  }

  return color
}

const getFontSize = (props) => {
  let size = Size.FONT.BUTTON

  if (props.fontSize) {
    size = props.fontSize
  }

  return size
}

const getColor = (props) => {
  let color = Color.FONT.MENU_DARK

  if (props.primary) {
    color = Color.FONT.BUTTON_PRIMARY
  }

  if (props.disabled) {
    color = Color.FONT.BUTTON_DISABLED
  }

  return color
}

const getCursor = (props) => {
  let cursor = 'pointer'

  if (props.disabled) {
    cursor = 'default'
  }

  return cursor
}

const Wrapper = styled(motion.button)`
  ${(props) => css`
    padding: 10px 28px;
    width: ${props.width}px;
    min-width: ${props.width ? props.width : '300'}px;
    height: ${props.height}px;
    min-height: 48px;
    border: ${getBorder(props)};
    border-radius: ${Border.BUTTON_RADIUS};
    opacity: ${props.disabled && 1};
    pointer-events: ${props.disabled ? 'none' : 'cursor'};
    background: ${getBackgroundColor(props)};
    text-align: center;
    line-height: 14px;
    font-size: ${getFontSize(props)};
    font-weight: ${Size.FONT.WEIGHT};
    color: ${getColor(props)};
    cursor: ${getCursor(props)};
    ${MEDIA_QUERY.PC} {
      margin-top: 24px;
      &:hover {
        opacity: 0.5;
      }
    }
  `}
  font-family: '游ゴシック体', YuGothic, '游ゴシック Medium', 'Yu Gothic Medium', '游ゴシック', 'Yu Gothic',
    -apple-system, BlinkMacSystemFont, 'Hiragino Kaku Gothic ProN', 'Noto Sans JP', 'メイリオ', Meiryo, Sans-Serif;
`

Button.propTypes = {
  type: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  primary: PropTypes.bool,
  secondury: PropTypes.bool,
  fontSize: PropTypes.string,
}
